var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RssList"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('RssListItem',{attrs:{"index":index,"title":item.title,"sub":_vm.sub ? item.sub : ''},on:{"select":function($event){return _vm.select(index)}}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }